const ScrollProgress = () => (
  <div className="scroll-progress" aria-hidden="true">
    <span className="scroll-progress__bar" />
  </div>
);

export default ScrollProgress;
